import { HHTypography } from '@hinge-health/react-component-library';
import {
  useGetContractsV2Query,
  useGetContractTemplatesQuery,
} from '../../types';
import { findActiveContract } from '../../utils/contract-utils';
import ContractDetailView from '../contract/contract-view-components/contract-detail-view';
import LoadingComponent from '../utils/loading';

interface ClientInsurerContractDrawerContentProps {
  clientInsurerId: number;
}

export const ClientInsurerContractDrawerContent = ({
  clientInsurerId,
}: ClientInsurerContractDrawerContentProps): JSX.Element => {
  const { data, loading, error } = useGetContractsV2Query({
    variables: {
      clientsInsurerIds: [clientInsurerId],
      includeVoided: false,
      page: 1,
      size: 100,
    },
  });
  const {
    data: templatesData,
    loading: templatesLoading,
    error: templatesError,
  } = useGetContractTemplatesQuery();

  if (loading || templatesLoading) return <LoadingComponent center />;

  if (error || templatesError) {
    return (
      <HHTypography hhVariant="body">
        Failed to load contract details.
      </HHTypography>
    );
  }

  const contract = findActiveContract(data?.getContractsV2?.items ?? []);
  const templates = templatesData?.getContractTemplates ?? [];

  if (!contract) {
    return (
      <HHTypography hhVariant="body">No active contract found</HHTypography>
    );
  }

  return (
    <ContractDetailView contract={contract} templates={templates} slimDisplay />
  );
};
